<template>
  <div class="full-html-editor">
    <div class="full-html-editor-card">
      <label class="full-html-editor-label" for="full-html-content">HTML</label>
      <textarea
        id="full-html-content"
        :value="value"
        class="full-html-editor-textarea"
        spellcheck="false"
        @input="$emit('input', $event.target.value)"
      ></textarea>
      <div class="full-html-editor-actions">
        <Button
          label="Salvar"
          color="green"
          textColor="white"
          textSize="1rem"
          :loading="loading"
          @click="$emit('save')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Button from "../_v2/ui/Button.vue";

export default {
  name: "FullHtmlEditor",
  components: { Button },

  props: {
    value: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.full-html-editor {
  min-height: 100vh;
  padding: 32px;
  background: #f5f7f9;
  font-family: Inter, sans-serif;
}

.full-html-editor-card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  height: calc(100vh - 64px);
  padding: 20px;
  border: 1px solid rgba(102, 109, 128, 0.16);
  border-radius: 8px;
  background: #fff;
}

.full-html-editor-label {
  color: #192b46;
  font-size: 16px;
  font-weight: 700;
}

.full-html-editor-textarea {
  flex: 1;
  width: 100%;
  min-height: 0;
  padding: 16px;
  border: 1px solid #dfe0e3;
  border-radius: 6px;
  outline: none;
  resize: none;
  color: #192b46;
  background: #fbfcfd;
  font-family: Consolas, "Courier New", monospace;
  font-size: 13px;
  line-height: 1.5;
}

.full-html-editor-textarea:focus {
  border-color: #0079cb;
  box-shadow: 0 0 0 3px rgba(0, 121, 203, 0.12);
}

.full-html-editor-actions {
  display: flex;
  justify-content: flex-end;
}
</style>
